import * as React from 'react';

import { createReactRenderer, getReactNodes } from 'helpers/react-renderer';
import { hasFeature } from 'root/api/admin/features';
import { Config, ConfigProvider } from 'root/apps/contexts/ConfigContext';
import { UserPreference, UserPreferencesProvider } from 'root/apps/contexts/UserPreferencesContext';

import ErrorMessageProvider from './contexts/ErrorMessage';
import StatusDataProvider from './contexts/StatusData';
import ImportItemView from './Views/index';

interface InventoryImportProps {
  config?: Config;
  userPreferences?: UserPreference[];
}

const InventoryImport: React.FC<InventoryImportProps> = ({ config = {}, userPreferences = [] }) => {
  return (
    <ConfigProvider config={config}>
      <UserPreferencesProvider userPreferences={userPreferences}>
        <ErrorMessageProvider>
          <StatusDataProvider>
            <ImportItemView />
          </StatusDataProvider>
        </ErrorMessageProvider>
      </UserPreferencesProvider>
    </ConfigProvider>
  );
};

const RenderedComponent = createReactRenderer({
  component: InventoryImport,
  selector: '[data-react-root="InventoryImport"]',
});

export default InventoryImport;

history.onChangeState(
  [
    {
      name: ['inventory_count.views.inventory_count'],
      form_name: 'view',
      tab: 'count',
      id: undefined,
    },
  ],
  ({ form_name: formName, tab }) => {
    if (formName === 'view' && tab === 'count') {
      getReactNodes('[data-react-root="InventoryImport"]').forEach(async (node) => {
        if (node.offsetWidth) {
          if (!(await hasFeature('InventoryCountScanQueue'))) {
            node.parentElement!.style.width = `20vw`;
          }
        }
      });
    }

    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
